<template>

    <v-row>

        <!-- Actions -->
        <ActionDropdown 
            :items="actions"
            context="Pricelists"
            alvqa="erp-pricelists"
            cols="2"
        /> 

        <!-- Header Stats -->
        <v-col 
            cols="4"
            v-if="totalRecords !== null"
            align-self="center"
            class="v-label theme--light mt-3"
            >
            <BaseHeaderStats context="Pricelists" typeStats="LIST" alvqa="erp-pricelists-list" />
        </v-col>

        <v-spacer />

        <!-- New Pricelist -->
        <v-col 
            xl="2"
            lg="3"
            align-self="end"
            cols="2"
            >
            <BaseButton
                label="lang_ERP_PRICELISTS_BUTTON_CAPTION_ADD_NEW_PRICELIST"
                :to="{ name: editForm, params: { alvId: 'new' } }"
                block
                color="buttonNewEntity"
                alvqa='erp-pricelists-list-button-new'
            />
        </v-col>

    </v-row>    
</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'

export default {
    name: "PricelistsTopSlot",
    data() {
        return {
            editForm: "PricelistsEdit",
        }
    },
    components: {
        BaseHeaderStats,
        BaseButton,
        ActionDropdown
    },
    computed:{
        totalRecords() { return this.$store.getters.getTotalRecords },
        
        actions() {
            return [
                {text: this.$t('lang_GENERIC_CAPTION_COPY'), value: 'copy', alvqa: 'erp-pricelists-list-action-dropdown-copy'},
                {text: this.$t('lang_GENERIC_CAPTION_DELETE'), value: 'delete', alvqa: 'erp-pricelists-list-action-dropdown-delete'},
            ]
        }
    }
}
</script>